import React from "react"
import PropTypes from "prop-types"
// import check from '../../../../assets/icons/check.svg';
// import cross from '../../../../assets/icons/cross.svg';
import style from "./Checkbox.module.css"

const Checkbox = props => {
  // Props
  // selected: bool, false
  // pressed: function to handle changing of state

  const { name, label, checked, invalid, pressed, disabled } = props

  console.log("Checkbox", label, invalid ? "Invalid" : "Valid")

  return (
    <label for={name} style={{ display: "flex", alignItems: "center" }}>
      <button
        className={invalid ? style.invalid : style.container}
        onClick={pressed}
        disabled={disabled}
        style={{
          backgroundColor: checked ? "#09CCC4" : "#fff",
        }}
        title={`Press to ${checked ? "uncheck" : "check"} this option`}
      />
      <span style={{ marginRight: 24, marginLeft: 16, fontWeight: 600 }}>
        {label}
      </span>
      {/* The Form gets data from here */}
      <input
        name={name}
        id={name}
        type="checkbox"
        hidden={true}
        tabIndex="-1"
        value="Y"
        checked={checked}
      />
    </label>
  )
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
}

export default Checkbox
